import { atom } from "jotai";

export const batchNosAtom = atom<string[]>([]);
